import React from 'react';
import { useAppSelector } from 'redux/store';
import RatioGauge from "./RatioGauge";


const RatioGauge_LowMacro = () => {
    const ratio = useAppSelector((state => state.user.ratio.LowMacro));

    return (
        <RatioGauge ratio={ratio} />
    )
};

export default RatioGauge_LowMacro;